// extracted by mini-css-extract-plugin
module.exports = {"loadingMessageContainer":"HotelBlock_loadingMessageContainer__2VLI2","iconSync":"HotelBlock_iconSync__19Lq9","fa-spin":"HotelBlock_fa-spin__-iIlw"};